module.exports = __webpack_public_path__ + "static/media/usd-circle.00555181.svg";